import { useLayoutEffect, useState, type RefObject } from 'react';
import type { CameraPadding } from '../domain/camera-plan';

/** Observe the currently mounted overlay and discard callbacks from a removed surface. */
export function useOverlayCameraPadding(root: RefObject<HTMLElement | null>, enabled: boolean,
  measure: (element: HTMLElement) => CameraPadding | undefined) {
  const [padding, setPadding] = useState<CameraPadding | undefined>();
  useLayoutEffect(() => {
    if (!root.current || !enabled) { setPadding(undefined); return; }
    const element = root.current;
    const update = () => {
      if (!element.isConnected || root.current !== element) return;
      const bounds = element.getBoundingClientRect();
      if (bounds.width <= 0 || bounds.height <= 0) return;
      const next = measure(element);
      if (next) setPadding(previous => JSON.stringify(previous) === JSON.stringify(next) ? previous : next);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    for (const child of element.querySelectorAll('.social-title, .social-footer, .social-credits, .legacy-map-clear-area, .ride-panel, .telemetry-dock, .footer')) observer.observe(child);
    return () => observer.disconnect();
  }, [root, enabled, measure]);
  return enabled ? padding : undefined;
}
